import { Attrs, MinzeElement } from 'minze'

export interface LvcFacebookIcon {}

export class LvcFacebookIcon extends MinzeElement {
  attrs: Attrs = [
    ['variant', 'default'],
    ['width', '32px'],
    ['height', '32px'],
  ]
  html = () => `

${
  this.variant === 'simple'
    ? `<svg width="22" height="25" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.34427 0.69936L5.60371 0.687012C2.56188 0.687012 1.8709 3.06969 1.8709 4.59085V6.71823H0.111328V10.0061H1.8709V19.3131H5.57103V10.0061H8.06662L8.38959 6.72139H5.57103V4.7867C5.57103 4.06101 6.02967 3.89043 6.35593 3.89043H8.34427V0.69936Z" fill="#1E007D"/>
</svg>`
    : ` <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.0667 14.4598H21.5667V12.3865C21.5667 11.8276 21.6501 11.4947 21.8195 11.2932C21.9725 11.1112 22.2936 10.9265 23.0667 10.9265H25.1867H25.6867V10.4265V6.8265V6.37827L25.2412 6.32947C24.1967 6.21511 23.1466 6.16066 22.096 6.1664C21.3235 6.11421 20.5489 6.23017 19.8255 6.50638C19.096 6.78493 18.4362 7.21972 17.8925 7.78026C17.3488 8.34079 16.9343 9.01349 16.678 9.75117C16.4247 10.4807 16.3322 11.2562 16.4067 12.0246V14.4998H13.4401H12.9401V14.9998V18.9998V19.4998H13.4401H16.4067V28.8332H4.13341C4.00647 28.8332 3.88077 28.8082 3.76349 28.7596L3.57215 29.2215L3.76348 28.7596C3.6462 28.711 3.53964 28.6398 3.44988 28.55C3.36012 28.4603 3.28891 28.3537 3.24033 28.2364C3.19175 28.1191 3.16675 27.9934 3.16675 27.8665V4.13317C3.16675 3.87679 3.26859 3.63092 3.44988 3.44963C3.63116 3.26835 3.87704 3.1665 4.13341 3.1665H27.8667C27.9937 3.1665 28.1194 3.19151 28.2367 3.24009C28.354 3.28867 28.4605 3.35987 28.5503 3.44963C28.64 3.5394 28.7113 3.64596 28.7598 3.76324L29.2191 3.57302L28.7598 3.76324C28.8084 3.88053 28.8334 4.00623 28.8334 4.13317V27.8665C28.8334 27.9934 28.8084 28.1191 28.7598 28.2364L29.2218 28.4278L28.7598 28.2364C28.7113 28.3537 28.64 28.4603 28.5503 28.55L28.9038 28.9036L28.5503 28.55C28.4605 28.6398 28.354 28.711 28.2367 28.7596L28.428 29.2215L28.2367 28.7596C28.1194 28.8082 27.9937 28.8332 27.8667 28.8332H21.5667V19.4598H24.5467H24.986L25.0426 19.0243L25.5626 15.0243L25.636 14.4598H25.0667Z" fill="#1E007D" stroke="#1E007D"/>
    </svg>
`
}
   
  `

  css = () => `
    
  `
}
